import { Currency, currencySymbol } from "@/lib/currency";

export type Pack = "single" | "triple";
export type Mode = "portrait" | "scene" | "pet";

// Numeric prices are identical across currencies per business rule.
// The symbol is chosen by the visitor's detected currency.
const BASE: Record<Pack, number> = {
  single: 4.99,
  triple: 9.99,
};

const SCENE_DELTA = 2;

const PET: Record<Pack, number> = {
  single: 4.99,
  triple: 9.99,
};

export function getPriceNumber(pack: Pack, mode: Mode): number {
  if (mode === "pet") return PET[pack];
  if (mode === "scene") return BASE[pack] + SCENE_DELTA;
  return BASE[pack];
}

export function formatPrice(n: number, currency: Currency = "usd"): string {
  return `${currencySymbol(currency)}${n.toFixed(2)}`;
}

export function getPrice(pack: Pack, mode: Mode, currency: Currency = "usd"): string {
  return formatPrice(getPriceNumber(pack, mode), currency);
}

export const MODE_LABEL_KEY: Record<Mode, string> = {
  portrait: "mode.portrait",
  scene: "mode.scene",
  pet: "mode.pet",
};

export const MODE_DESC_KEY: Record<Mode, string> = {
  portrait: "mode.portraitDesc",
  scene: "mode.sceneDesc",
  pet: "mode.petDesc",
};
